const GAProfile = props => (
  <div className='ga-profile' onClick={() => props.onClick(props.id)}>
    <div className='ga-profile-name'>{ props.name }</div>
    <div>{ props.websiteUrl }</div>
  </div>
)

export default GAProfile
